/*
 * Curated phrase safelist. No free-text chat — this is load-bearing per CLAUDE.md.
 *
 * To expand the catalog, edit this file. TASK-04 plans to grow this to ~30.
 * Keep the tone: warm, low-stakes, social, never sarcastic.
 */

/** Phrases offered in the "Say…" modal for the local player. */
export const PHRASES: readonly string[] = [
  'hi! 🌿',
  'hello!',
  'wow!',
  'cozy ✨',
  "let's play!",
  'good night',
  'thank you!',
  'haha',
];

/** Phrases NPCs spontaneously bubble while wandering. */
export const NPC_PHRASES: readonly string[] = [
  'hi!',
  'nice hat!',
  'cozy night',
  '✨',
  'mmm mushrooms',
  'wave 👋',
  "let's play!",
];

/** Names used for NPCs spawned in the v0.2 prototype. */
export const NPC_NAMES: readonly string[] = [
  'Willow',
  'Pip',
  'Mosswick',
  'Clover',
  'Hazel',
  'Bramble',
];

/** Default suggested names if the player hasn't entered one yet. */
export const DEFAULT_NAMES: readonly string[] = [
  'Sprout',
  'Cricket',
  'Mossy',
  'Pebble',
  'Sage',
  'Fern',
];
